export const LIKE = 'like'
export const XMAS = 'xmas'
export const NEW_YEAR = 'new_year'
